/** Clés i18n génériques pour les menus d'actions des tableaux (⋮). */
export const ACTION_I18N_KEYS = {
  menuLabel: "actions.menuLabel",
  edit: "actions.edit",
  view: "actions.view",
  duplicate: "actions.duplicate",
  delete: "actions.delete",
  add: "actions.add",
  print: "actions.print",
} as const;

export type ActionI18nKey =
  (typeof ACTION_I18N_KEYS)[keyof typeof ACTION_I18N_KEYS];
